module.exports = __webpack_public_path__ + "static/media/canais-subheader.bb693d99.jpg";